import { useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  // First attempt: immediate scroll before paint
  useLayoutEffect(() => {
    // Check if we should preserve scroll position for Products page
    if (pathname === '/coffee-selection') {
      const shouldRestoreScroll = sessionStorage.getItem('restoreProductsScroll');
      if (shouldRestoreScroll === 'true') {
        // Don't scroll - let Products page handle it
        return;
      }
    }

    // Instant scroll to top with no animation (scroll-behavior: auto in CSS)
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Reset any scroll containers
    const scrollContainers = document.querySelectorAll('[data-scroll-container]');
    scrollContainers.forEach(container => {
      if (container instanceof HTMLElement) {
        container.scrollTop = 0;
      }
    });
  }, [pathname]);

  // Second attempt: after render completes (backup)
  useEffect(() => {
    // Check if we should preserve scroll position for Products page
    if (pathname === '/coffee-selection') {
      const shouldRestoreScroll = sessionStorage.getItem('restoreProductsScroll');
      if (shouldRestoreScroll === 'true') {
        return;
      }
    }

    // Delayed scroll to catch any late renders
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);

    return () => clearTimeout(timer);
  }, [pathname]);
};
